import { render } from "./CoBrandMeridian.vue?vue&type=template&id=eeb739b2&scoped=true"
import script from "./CoBrandMeridian.vue?vue&type=script&lang=js"
export * from "./CoBrandMeridian.vue?vue&type=script&lang=js"

import "./CoBrandMeridian.vue?vue&type=style&index=0&id=eeb739b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eeb739b2"]])

export default __exports__